export default __webpack_public_path__ + "static/media/CloudCTI.489bda5c.png";